import React from "react";
import "./PremiumCalloutSummary.scss";
import premiumBadge from "../../../static/img/icon-premium-badge-premium-gradient-stroke@3x.png";

export interface IPremiumCalloutSummaryProps {
    className?: string;
    copyTextUpper: React.ReactNode;
    copyTextLower: React.ReactNode;
}

const PremiumCalloutSummary: React.FC<IPremiumCalloutSummaryProps> = ({
    className = "",
    copyTextUpper,
    copyTextLower,
}) => {
    return (
        <div
            className={`PremiumCalloutSummary ${className}`}
            role="group"
            aria-label="Order Summary"
        >
            <img
                className="PremiumCalloutSummary__badge"
                src={premiumBadge}
                alt="Premium"
                loading="lazy"
            />
            <div className="PremiumCalloutSummary__copy">
                <div className="PremiumCalloutSummary__upper">
                    {copyTextUpper}
                </div>
                <div className="PremiumCalloutSummary__lower">
                    {copyTextLower}
                </div>
            </div>
        </div>
    );
};

export default PremiumCalloutSummary;
